// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__CazLM","layout-body":"style_layout-body__IgDJH"};